module.exports = __webpack_public_path__ + "img/capa-padrao-simulado.f4586eab.png";